<template>
<div>
  <vue-apex-charts
    class="mt-6 mb-8"
    type="donut"
    :height="height"
    :options="options"
    :series="series"
    @dataPointSelection="emitClickSection"
  />
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts
  },
  props:{
    centerLabel:{
      type:String,
      default:'Total'
    },
    center_color:{
      type:String,
      default:'#000000'
    },
    chartId:{
      type:String,
      required:true
    },
    series:{
      type: Array,
      default: function () {
        return []
      }
    },
    height:{
      type: String,
      default:'250'
    },
    centerFontSize:{
      type: String,
      default:'24px'
    },
    valueFontSize:{
      type: String,
      default:'24px'
    }

  },
  data() {
    return {
       options: {
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  fontSize: this.centerFontSize ,
                  color: this.center_color,
                  label: this.centerLabel,
                },
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                  offsetY: -10
                },
                value: {
                  show: true,
                  fontSize: this.valueFontSize,
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 400,
                  color: undefined,
                  offsetY: 16
                }
              }
            }
          }
        },
        chart: {
          id: this.chartId,
        },
        tooltip: {
          enabled: true,
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            return `<div style="display:inline-flex">
                      <div class="circulo" style="background:${w.globals.fill.colors[seriesIndex]}"></div>
                      <div class="tooltip-label">
                        ${w.globals.labels[seriesIndex]}: ${series[seriesIndex]}
                      </div>
                    </div>`
          }
        },
        legend: {
          show:false,
          position: 'bottom',
        },
        labels: ['Label'],
        dataLabels: {
          enabled: false
        }
      }
    }
  },
  methods:{
    emitClickSection(event, chartContext, config){
      this.$emit('clickDonutSection',config)
    }
  }
}
</script>

<style>

.circulo {
  position: relative;
  width: 12px;
  height: 12px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  top: 4px;
  margin-left: 3px;
}

.tooltip-label {
  margin-left: 3px;
  margin-right: 3px;
}

</style>
